export const DEFAULT_META = {
  description: '',
  title: '',
  keywords: '',
};
